"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const SubmenuTitle = dynamic(
  async () => (await import("./SubmenuTitle")).SubmenuTitle
);

export const submenuTitleInputs = [
  {
    name: "variant",
    type: "string",
    enum: ["general", "ploomClub"],
    defaultValue: "general",
  },
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Shop",
  },
  {
    name: "link",
    type: "object",
    showIf: `options.get("variant") === "ploomClub"`,
    subFields: [
      { name: "text", type: "string", required: true },
      { name: "href", type: "url", required: true },
    ],
    defaultValue: {
      text: "View all",
      href: "/shop",
    },
  },
  {
    name: "descriptionPrefix",
    type: "string",
    showIf: `options.get("variant") === "ploomClub"`,
    defaultValue: "Membership status",
  },
  {
    name: "secondDescriptionPrefix",
    type: "string",
    showIf: `options.get("variant") === "ploomClub"`,
    defaultValue: "Points",
  },
] as const satisfies Inputs;

export const SubmenuTitleComponent: RegisteredComponent = {
  name: "SubmenuTitle",
  component: SubmenuTitle,
  inputs: submenuTitleInputs,
};
